import type { ReactNode } from 'react';
import useEntrance from '@/hooks/useInView';

interface ExposureResolveProps {
  className?: string;
  children: ReactNode;
}

/** Motion B — photo stays visible and in place; exposure/colour resolve to natural. */
export default function ExposureResolve({ className = '', children }: ExposureResolveProps) {
  const { ref, pending } = useEntrance<HTMLDivElement>(0.3);
  return (
    <div ref={ref} className={`mw-expose ${pending ? 'mw-expose-pending' : ''} ${className}`}>
      {children}
    </div>
  );
}